/* Project Import will be here */
import { getClubEnrollmentInfoApi, getClubEnrollmentCalcApi, saveClubEnrollmentApi, getExistingClubEnrollmentStatusApi } from "services/rbp/rbpService";
import { getErrorObject, errorToast } from "utilities/utils";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    ENROLLMENT_INFO_REQUEST: "clubEnrollment/ENROLLMENT_INFO_REQUEST",
    ENROLLMENT_INFO_SUCCESS: "clubEnrollment/ENROLLMENT_INFO_SUCCESS",
    ENROLLMENT_INFO_FAILURE: "clubEnrollment/ENROLLMENT_INFO_FAILURE",
    ENROLLMENT_CALCULATION_REQUEST: "clubEnrollment/ENROLLMENT_CALCULATION_REQUEST",
    ENROLLMENT_CALCULATION_SUCCESS: "clubEnrollment/ENROLLMENT_CALCULATION_SUCCESS",
    ENROLLMENT_CALCULATION_FAILURE: "clubEnrollment/ENROLLMENT_CALCULATION_FAILURE",
    CLEAR_ENROLLMENT_DATA: "clubEnrollment/CLEAR_ENROLLMENT_DATA",
    CLEAR_CALC_DATA: "clubEnrollment/CLEAR_CALC_DATA",
    UPDATE_CONFIRMATION_DATA: "clubEnrollment/UPDATE_CONFIRMATION_DATA",
    ENROLLMENT_SUBMIT_REQUEST: "clubEnrollment/ENROLLMENT_SUBMIT_REQUEST",
    ENROLLMENT_SUBMIT_SUCCESS: "clubEnrollment/ENROLLMENT_SUBMIT_SUCCESS",
    ENROLLMENT_SUBMIT_FAILURE: "clubEnrollment/ENROLLMENT_SUBMIT_FAILURE",
    EXISTING_ENROLLMENT_INFO_REQUEST: "clubEnrollment/EXISTING_ENROLLMENT_INFO_REQUEST",
    EXISTING_ENROLLMENT_INFO_SUCCESS: "clubEnrollment/EXISTING_ENROLLMENT_INFO_SUCCESS",
    EXISTING_ENROLLMENT_INFO_FAILURE: "clubEnrollment/EXISTING_ENROLLMENT_INFO_FAILURE"
};

const initialState = {
    existingEnrollment: {
        isLoading: false,
        error: null,
        data: {}
    },
    info: {
        isLoading: false,
        error: null,
        data: {}
    },
    calc: {
        isLoading: false,
        error: null,
        data: {},
        askConfirmation: false,
        bonusPercentage: 0
    },
    isSubmitLoading: false
};

export const clubEnrollment = (state = initialState, action) => {
    switch (action.type) {
        case types.ENROLLMENT_INFO_REQUEST: {
            return {
                ...state,
                info: {
                    ...state.info,
                    isLoading: true
                }
            };
        }

        case types.ENROLLMENT_INFO_SUCCESS: {
            return {
                ...state,
                info: {
                    ...state.info,
                    ...action.payload,
                    isLoading: false
                }
            };
        }

        case types.ENROLLMENT_INFO_FAILURE: {
            return {
                ...state,
                info: {
                    ...initialState.info
                }
            };
        }

        case types.EXISTING_ENROLLMENT_INFO_REQUEST: {
            return {
                ...state,
                existingEnrollment: {
                    ...state.existingEnrollment,
                    isLoading: true
                }
            };
        }

        case types.EXISTING_ENROLLMENT_INFO_SUCCESS: {
            return {
                ...state,
                existingEnrollment: {
                    ...state.existingEnrollment,
                    ...action.payload,
                    isLoading: false
                }
            };
        }

        case types.EXISTING_ENROLLMENT_INFO_FAILURE: {
            return {
                ...state,
                existingEnrollment: {
                    ...initialState.existingEnrollment
                }
            };
        }

        case types.ENROLLMENT_CALCULATION_REQUEST: {
            return {
                ...state,
                calc: {
                    ...state.calc,
                    isLoading: true
                }
            };
        }

        case types.ENROLLMENT_CALCULATION_SUCCESS: {
            return {
                ...state,
                calc: {
                    ...state.calc,
                    ...action.payload,
                    isLoading: false
                }
            };
        }

        case types.ENROLLMENT_SUBMIT_REQUEST: {
            return {
                ...state,
                isSubmitLoading: true
            };
        }

        case types.ENROLLMENT_SUBMIT_SUCCESS: {
            return {
                ...state,
                isSubmitLoading: false
            };
        }

        case types.ENROLLMENT_SUBMIT_FAILURE: {
            return {
                ...state,
                isSubmitLoading: false
            };
        }

        case types.ENROLLMENT_CALCULATION_FAILURE: {
            return {
                ...state,
                info: {
                    ...state.info
                },
                calc: {
                    ...initialState.calc
                }
            };
        }

        case types.CLEAR_CALC_DATA: {
            return {
                ...state,
                calc: {
                    ...initialState.calc
                }
            };
        }

        case types.CLEAR_ENROLLMENT_DATA: {
            return {
                ...initialState,
                info: {
                    ...initialState.info
                },
                calc: {
                    ...initialState.calc
                }
            };
        }

        case types.UPDATE_CONFIRMATION_DATA: {
            return {
                ...state,
                info: {
                    ...state.info
                },
                calc: {
                    ...state.calc,
                    ...action.payload
                }
            };
        }

        default:
            return state;
    }
};

export const clearEnrollmentData = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CLEAR_ENROLLMENT_DATA });
    };
};

export const resetCalculationData = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CLEAR_CALC_DATA });
    };
};

export const updateConfirmationData = (showConfirmation, confirmationPercentage) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.UPDATE_CONFIRMATION_DATA, payload: { askConfirmation: showConfirmation, bonusPercentage: confirmationPercentage } });
    };
};

/* Get existing club enrollment status */
export const getExistingClubEnrollmentStatus = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.EXISTING_ENROLLMENT_INFO_REQUEST });
        try {
            const response = await getExistingClubEnrollmentStatusApi();
            dispatch({ type: types.EXISTING_ENROLLMENT_INFO_SUCCESS, payload: { data: response.data.Data } });

            /* Get the club enrollment info */
            if (!response.data.Data.IsEnrolledAlready)
                dispatch(getClubEnrollmentInfo());
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.EXISTING_ENROLLMENT_INFO_FAILURE));
        }
    };
};

/* Get club enrollment club info */
export const getClubEnrollmentInfo = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ENROLLMENT_INFO_REQUEST });
        try {
            const response = await getClubEnrollmentInfoApi();
            dispatch({ type: types.ENROLLMENT_INFO_SUCCESS, payload: { data: response.data.Data } });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.ENROLLMENT_INFO_FAILURE));
        }
    };
};

/* Get club enrollment club calc */
export const getClubEnrollmentCalc = (data) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ENROLLMENT_CALCULATION_REQUEST });
        try {
            const response = await getClubEnrollmentCalcApi(data);
            dispatch({
                type: types.ENROLLMENT_CALCULATION_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.ENROLLMENT_CALCULATION_FAILURE));
        }
    };
};

/* Get club enrollment club info */
export const saveClubEnrollment = (data, successCallback, failureCallback) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ENROLLMENT_SUBMIT_REQUEST });
        try {
            await saveClubEnrollmentApi(data);
            dispatch({ type: types.ENROLLMENT_SUBMIT_SUCCESS });
            dispatch(updateConfirmationData(false, 0));

            /* Call success callback function */
            successCallback();
        }
        catch (error) {
            dispatch(updateConfirmationData(false, 0));
            dispatch(promiseCatchBlock(error, types.ENROLLMENT_SUBMIT_FAILURE, true));
        }
    };
};

const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "")
            dispatch({ type: type, payload: { error: message } });

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};